export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/arrayToObject.js
// module id = 2755
// module chunks = 0